import i18n from "i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next, useTranslation  } from "react-i18next";

enum Language {
  ENGLISH = "en-US",
  SWEDISH = "sv-SE",
  NORWEGIAN= "nb-NO"
}

export default i18n;

export const i18nProducer: producer = async ({
  isReady = update.isReady.languages,
  updateLangId = update.langId,
  updateLanguageChoice = update.languageChoice,

}) => {
  console.log("ENV  ", process.env.NODE_ENV);
  const urlParams = new URLSearchParams(window.location.search);
  let lng = urlParams.get('lang') || Language.SWEDISH;
  let path = "/recipient-dashboard/locales/{{lng}}/{{ns}}.json";

  if (process.env.NODE_ENV === "development") {
    path = "/locales/{{lng}}/{{ns}}.json";
    lng = Language.SWEDISH;
  }

  if (lng === Language.ENGLISH) {
    updateLangId.set(Language.ENGLISH);
    updateLanguageChoice.set("EN");
  }

  if (lng === Language.NORWEGIAN) {
    updateLangId.set(Language.NORWEGIAN);
    updateLanguageChoice.set("NO");
  }

  if (lng === Language.SWEDISH) {
    updateLangId.set(Language.SWEDISH);
    updateLanguageChoice.set("SE");
  }

  // http://localhost:8080/locales/en/common.json
  // http://localhost:8080/locales/sv-SE/common.json
  const i18nextOptions: any = {
    lng: lng,
    ns: ["common"],
    defaultNS: "common",
    debug: true,
    backend: {
      loadPath: path,
    },
    fallbackLng: Language.ENGLISH,
    initImmediate: true,
    react: {
      bindI18n: 'languageChanged',
      bindI18nStore: '',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
      useSuspense: true,
    }
  };

  i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init(i18nextOptions, (x) => x && isReady.set(true));
};
